// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const METADATA = {
    "tag": "sd-6.77.6-alpha-02c8e7bd"
};
/* tslint:enable */
